import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

export default function RefuseTreatmentModal({ open, onClose, onConfirm, treatmentDescription }) {
  const [refusalReason, setRefusalReason] = useState('');

  useEffect(() => {
    if (open) {
      setRefusalReason('');
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="refuse-dialog-title"
      aria-describedby="refuse-dialog-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="refuse-dialog-title">
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Marcar como não aprovado
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="refuse-dialog-description" sx={{ mb: 2 }}>
          {treatmentDescription
            ? `O orçamento "${treatmentDescription}" será marcado como não aprovado pelo paciente.`
            : 'O orçamento será marcado como não aprovado pelo paciente.'}
        </DialogContentText>
        <TextField
          label="Motivo da recusa"
          value={refusalReason}
          onChange={(event) => setRefusalReason(event.target.value)}
          placeholder="Ex.: valor acima do esperado, vai pensar, plano não cobre"
          helperText="Ajuda a entender por que orçamentos não são aprovados."
          multiline
          minRows={3}
          fullWidth
          required
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={() => onConfirm(refusalReason.trim())}
          variant="contained"
          color="error"
          disabled={refusalReason.trim() === ''}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

RefuseTreatmentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  treatmentDescription: PropTypes.string,
};

RefuseTreatmentModal.defaultProps = {
  treatmentDescription: '',
};
